module.exports = __webpack_public_path__ + "static/6-3249505e555c8c5d17ce8c67ebd0506b.png";